import { RECEIVE_FIELD } from '../constants/actionTypes';

export function receiveField(payload) {
  return {
    type: RECEIVE_FIELD,
    payload,
  };
}
